/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecutionsHistory
 */
export interface ExecutionsHistory {
    /**
     * 
     * @type {string}
     * @memberof ExecutionsHistory
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionsHistory
     */
    facility_id: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionsHistory
     */
    lead_id: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionsHistory
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionsHistory
     */
    lead_full_name: string;
}

/**
 * Check if a given object implements the ExecutionsHistory interface.
 */
export function instanceOfExecutionsHistory(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "facility_id" in value;
    isInstance = isInstance && "lead_id" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "lead_full_name" in value;

    return isInstance;
}

export function ExecutionsHistoryFromJSON(json: any): ExecutionsHistory {
    return ExecutionsHistoryFromJSONTyped(json, false);
}

export function ExecutionsHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecutionsHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'facility_id': json['facility_id'],
        'lead_id': json['lead_id'],
        'createdAt': json['createdAt'],
        'lead_full_name': json['lead_full_name'],
    };
}

export function ExecutionsHistoryToJSON(value?: ExecutionsHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'facility_id': value.facility_id,
        'lead_id': value.lead_id,
        'createdAt': value.createdAt,
        'lead_full_name': value.lead_full_name,
    };
}

